export const CatalogClassesKeys = {
  USERS_STATUS_CLASS: "USERS_STATUS_CLASS",
  ORDERS_STATUS_CLASS: "ORDERS_STATUS_CLASS",
  WORKPLACE_STATUS_CLASS: "WORKPLACE_STATUS_CLASS",
};
